import {
  arrayOf, extend, params, shape, string, bool
} from '@thd-nucleus/data-sources';

export const dataModel = extend({}, {
  product: params({ itemId: string().isRequired() }).shape({
    dataSources: string(),
    itemId: string(),
    specificationGroup: arrayOf(shape({
      specTitle: string(),
      specifications: arrayOf(shape({
        specName: string(),
        specValue: string()
      }))
    }))
  }),
  products: params({ itemIds: arrayOf(string().isRequired()).isRequired() }).arrayOf({
    dataSources: string(),
    identifiers: shape({
      itemId: string(),
      canonicalUrl: string(),
      productLabel: string(),
    }),
    itemId: string(),
    media: shape({
      images: arrayOf(
        shape({
          sizes: arrayOf(string()),
          subType: string(),
          type: string(),
          url: string(),
        })
      ),
    }),
    specificationGroup: arrayOf(shape({
      specTitle: string(),
      specifications: arrayOf(shape({
        specName: string(),
        specValue: string()
      }))
    }))
  })
});
